import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const StatCounter = ({ value, suffix = "", label }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = null;
    const duration = 1600;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * value));
      if (progress < 1) requestAnimationFrame(step);
      else setCount(value);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-display font-light text-5xl sm:text-6xl lg:text-7xl text-gold tracking-tight tabular-nums">
        {count}
        {suffix}
      </div>
      <div className="mt-3 label text-white/60">{label}</div>
    </div>
  );
};
